import React from 'react';

import { css, cx } from '@emotion/css';
import { Editor } from '@tiptap/core';

import { FontSizes } from '@/assets/fonts.ts';
import { useStyles } from '@/hooks/useStyles.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { RichTextFormattingButtons } from '@/uiKit/molecules/RichText/RichTextFormattingButtons.tsx';

export type TextEditorBubbleMenuProps = {
  editor: Editor;
  className?: string;
};

export const RichTextBubbleMenu: React.FC<TextEditorBubbleMenuProps> = ({
  editor,
  className,
}) => {
  const styles = useStyles(makeStyles);
  return (
    <div
      className={cx(styles.container, className)}
      id="rich-text-editor-bubble-menu"
    >
      <RichTextFormattingButtons
        toggled={{
          bold: editor.isActive('bold'),
          italic: editor.isActive('italic'),
          underlined: editor.isActive('underline'),
        }}
        onToggle={value => {
          switch (value) {
            case 'bold':
              editor.chain().focus().toggleBold().run();
              break;
            case 'italic':
              editor.chain().focus().toggleItalic().run();
              break;
            case 'underlined':
              editor.chain().focus().toggleUnderline().run();
              break;
          }
        }}
        color={editor.getAttributes('textStyle')['color'] ?? '#000'}
        onSelectColor={color => editor.chain().focus().setColor(color).run()}
      />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.tooltip,
  }),
  icon: css({
    width: FontSizes.bodyLarge,
    height: FontSizes.bodyLarge,
  }),
});
